import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Topbar({ left, right, overlay = false, className, children, ...rest }) {
    const useSlots = left !== undefined || right !== undefined;
    return (_jsx("div", { className: cn("fwfa-topbar", overlay && "fwfa-topbar--overlay", className), ...rest, children: useSlots ? (_jsxs(_Fragment, { children: [_jsx("div", { className: "fwfa-cluster", children: left }), _jsx("div", { className: "fwfa-cluster", children: right })] })) : (children) }));
}
//# sourceMappingURL=Topbar.js.map